export const members = [
  {
    id: '1',
    name: 'Artem Karpenko',
    role: 'Team lead',
    img: 'https://avatars.githubusercontent.com/u/101360953?v=4',
    gitHubLink: 'https://github.com/Ozozai12',
    LinkdInLink:'',
    movies:
      'Equilibrium, Back to the Future, Star Wars ep. 1-6',
    series: 'Chernobyl (HBO), Travelers',
    
  },
  {
    id: '2',
    name: 'Olga Mykhailova',
    role: 'Scrum-master',
    img: 'https://avatars.githubusercontent.com/u/100313107?v=4',
    gitHubLink: 'https://github.com/OlgaMykhailova',
    LinkdInLink: '',
    movies:`Forrest Gump (1994),  Don't Look Up (2021)`,
    series: 'Bron/Broen, Black Mirror',  
    
  },
  {
    id: '3',
    name: 'Olena Hras',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/100197147?v=4',
    gitHubLink: 'https://github.com/OlenaHras',
    LinkdInLink: '',
    movies: '',
    series: 'The Expanse, The Umbrella Academy',
    
  },
  {
    id: '4',
    name: 'Anastasiya Olhovik',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/93829935?v=4',
    gitHubLink: 'https://github.com/AnastasiyaOlhovik',
    LinkdInLink: '',
    movies: `Everybody's Fine`,
    series: 'Millionaires, Westworld',
     
  },
  {
    id: '5',
    name: 'Pavel Kreitsberg',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/99120090?v=4',
    gitHubLink: 'https://github.com/PavelKreitsberg',
    LinkdInLink: '',
    movies: 'Shutter Island, The Shawshank Redemption, Harry Potter, The Lord of the Rings',
    series: 'The Simpsons, 11.22.63, Ozark, Game of Thrones, Arcane',
     
  },
  {
    id: '6',
    name: 'Timofiy Tatarenko',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/100188867?v=4',
    gitHubLink: 'https://github.com/Xdecent0',
    LinkdInLink: '',
    movies: '',
    series: 'Family Guy',
     
  },
  {
    id: '7',
    name: 'Oleksii Shevchenko',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/94850347?v=4',
    gitHubLink: 'https://github.com/oleksii-she',
    LinkdInLink: '',
    movies: 'Snatch, RocknRolla, Django Unchained',
    series: 'The Sopranos, Sons of Anarchy',
     
  },
  {
    id: '8',
    name: 'Vadym Vasylenko',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/101503219?v=4',
    gitHubLink: 'https://github.com/wi2410',
    LinkdInLink: '',
    movies: 'Marvel Movies, Fast & Furious, Jason Statham movies',
    series: 'The Big Bang Theory, Person of Interest, The Blacklist, Men at Work, Why Women Kill.',
     
  },
  {
    id: '9',
    name: 'Valeriia Masiuk',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/99878558?v=4',
    gitHubLink: 'https://github.com/ValeriiaMasiuk',
    LinkdInLink: '',
    movies: 'The Age of Adaline',
    series: '',
    
  },
  {
    id: '10',
    name: 'Oleg Kaminskyi',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/100085494?v=4',
    gitHubLink: 'https://https://github.com/Psychedell',
    LinkdInLink: '',
    movies: '11 friends of ocean, Free Guy, Riddick, Guardians of the Galaxy,  Kong: Skull Island, Avatar, Men in Black, The Lord of the Rings, The Hunger Games, The Maze Runner',
    series: '',
    
  },
  {
    id: '11',
    name: 'Klyimus Vlad',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/99616484?v=4',
    gitHubLink: 'https://github.com/klimchanskii',
    LinkdInLink: '',
    movies: 'Shutter Island, Inception, Inglourious Basterds,',
    series: '',
    
  },
  {
    id: '12',
    name: 'Oleksii Reshetnyk',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/55344626?v=4',
    gitHubLink: 'https://github.com/oreshnyk',
    LinkdInLink: '',
    movies: 'The Prestige, Titanic, Citizen Kane',
    series: 'Dark, One Piece, Office',
    
  },
];